module.exports = __webpack_public_path__ + "assets/img/c7dc-ir.svg";